import { useState } from "react"
import {
  Alert,
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Stack,
  TextField,
} from "@mui/material"
import { ContentOwner } from "../../interfaces"
import { useCampaignsListQuery } from "../../store/advApi"
import { OrderPickerField } from "./orderPicker"

const CampaignPicker = ({
  value,
  onChange,
}: {
  value: number | null
  onChange: (id: number | null) => void
}) => {
  const { data, isFetching, isError, refetch } = useCampaignsListQuery({})
  return (
    <Stack spacing={1}>
      {isError && (
        <Alert
          severity="error"
          action={<Button onClick={() => refetch()}>Повторить</Button>}
        >
          Не удалось загрузить кампании
        </Alert>
      )}
      <Autocomplete
        options={data ?? []}
        loading={isFetching}
        value={data?.find((campaign) => campaign.id === value) ?? null}
        getOptionLabel={(campaign) => campaign.name}
        isOptionEqualToValue={(a, b) => a.id === b.id}
        onChange={(_, campaign) => onChange(campaign?.id ?? null)}
        renderInput={(params) => <TextField {...params} label="Кампания" />}
      />
    </Stack>
  )
}

export const ContentBindingSelector = ({
  pending,
  error,
  onClose,
  onSubmit,
}: {
  pending: boolean
  error: string | null
  onClose: () => void
  onSubmit: (owner: ContentOwner) => void
}) => {
  const [kind, setKind] = useState<ContentOwner["kind"]>("campaign")
  const [ownerId, setOwnerId] = useState<number | null>(null)
  return (
    <Dialog
      open
      fullWidth
      onClose={pending ? undefined : onClose}
      disableEscapeKeyDown={pending}
    >
      <DialogTitle>Привязать материал</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1 }}>
          {error && <Alert severity="error">{error}</Alert>}
          <TextField
            select
            label="Тип владельца"
            value={kind}
            disabled={pending}
            onChange={(event) => {
              setKind(event.target.value === "order" ? "order" : "campaign")
              setOwnerId(null)
            }}
          >
            <MenuItem value="campaign">Кампания</MenuItem>
            <MenuItem value="order">Ордер</MenuItem>
          </TextField>
          <fieldset
            disabled={pending}
            style={{ border: 0, padding: 0, margin: 0 }}
          >
            {kind === "campaign" ? (
              <CampaignPicker value={ownerId} onChange={setOwnerId} />
            ) : (
              <OrderPickerField
                value={ownerId === null ? [] : [ownerId]}
                onChange={(ids) => setOwnerId(ids.at(-1) ?? null)}
              />
            )}
          </fieldset>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button disabled={pending} onClick={onClose}>
          Отмена
        </Button>
        <Button
          disabled={pending || ownerId === null}
          onClick={() => {
            if (ownerId !== null) onSubmit({ kind, id: ownerId })
          }}
        >
          Привязать
        </Button>
      </DialogActions>
    </Dialog>
  )
}
